import { faPlus } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react';

import * as State from 'components/desktop/Ingredient/IngredientProducts/OrderGuideMapping/State';
import { OrderGuideListItem } from 'components/desktop/Ingredient/IngredientProducts/OrderGuideMapping/components/OrderGuideListItem';
import ProductSearchOverlay from 'components/desktop/Ingredient/IngredientProducts/OrderGuideMapping/components/ProductSearchOverlay';
import useState from 'components/desktop/Ingredient/IngredientProducts/OrderGuideMapping/useState';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import LoadingSpinner from 'components/desktop/_general/Loading/LoadingSpinner';
import { useInitialize } from 'hooks/useInitialize';

interface IProps {
	ingredientId: string;
}

const OrderGuideMapping = (props: IProps) => {
	const { t } = useTranslation();
	const { classes } = useStyles();

	const { state, handlers } = useState();
	const { isLoaded } = useInitialize(() => handlers.initialize(props.ingredientId));

	return (
		<div className="margin-top-25">
			<fieldset>
				<ProductSearchOverlay
					ingredientId={props.ingredientId}
					state={state}
					handlers={handlers}
				/>
				<div className="d-flex justify-content-between align-items-center">
					<h5 style={{ marginBottom: '20px' }}>{t('recipe:ORDER_GUIDE_PRODUCTS')}</h5>
					<button
						className="btn btn-primary btn-sm"
						onClick={() => handlers.openProductSearch(props.ingredientId)}
					>
						<FontAwesomeIcon icon={faPlus} className={classes.icon} />
						{t('_general:ADD')}
					</button>
				</div>
				<RenderIf condition={!isLoaded}>
					<LoadingSpinner />
				</RenderIf>
				<RenderIf condition={Boolean(isLoaded && !State.hasProducts(state))}>
					<div>{t('ingredient:NO_PRODUCTS_FOUND')}</div>
				</RenderIf>
				<RenderIf condition={Boolean(isLoaded && State.hasProducts(state))}>
					{state.orderGuides.map((orderGuide, i) => {
						return (
							<OrderGuideListItem
								key={i}
								orderGuide={orderGuide}
								handlers={handlers}
							/>
						);
					})}
				</RenderIf>
			</fieldset>
		</div>
	);
};

export default OrderGuideMapping;

export const useStyles = tss.create({
	icon: {
		marginRight: '5px',
	},
});
